// extracted by mini-css-extract-plugin
export default {"content":"FloorplanSummaryCard_content__EOnMN","summaryCard":"FloorplanSummaryCard_summaryCard__NHyiC"};